import {CompanyContext, CompanyContextValue} from "../../solicitation-new/context/companyContext";
import {useContext, useEffect, useState} from "react";
import {HttpSolicitation} from "../../../http/solicitation/httpSolicitation";
import {FilterSolicitationSearch, FilterSolicitationSearchFields} from "../../../types/solicitation/solicitationFilter";
import {Channels} from "../../../types/generalData";
import {Solicitation} from "../../../types/solicitation/solicitationData";
import {EntityListWithPaginationFields} from "../../../types/baseEntities";
import {Alert, Card, CardContent, CardHeader, Divider, Grid, Skeleton, Table, TableHead, TableRow, TableCell, TableBody} from "@mui/material";
import SolicitationTableRow from "../../solicitation-view/components/SolicitationTableRow";


const HomeSolicitationsSummary = () => {
    const {clientId} = useContext<CompanyContextValue>(CompanyContext)
    const [solicitations, setSolicitations] = useState<Solicitation[]>()
    const defaultFilter: FilterSolicitationSearch = {
        [FilterSolicitationSearchFields.SolicitationId]: undefined,
        [FilterSolicitationSearchFields.ClientId]: -1,
        [FilterSolicitationSearchFields.BusinessName]: '',
        [FilterSolicitationSearchFields.CUIT]: '',
        [FilterSolicitationSearchFields.SolicitationOriginId]: undefined,
        [FilterSolicitationSearchFields.OperationOriginId]: undefined,
        [FilterSolicitationSearchFields.BankCode]: undefined,
        [FilterSolicitationSearchFields.BranchCode]: undefined,
        [FilterSolicitationSearchFields.SolicitationStateCode]: undefined,
        [FilterSolicitationSearchFields.CommercialId]: undefined,
        [FilterSolicitationSearchFields.RegisterDate]: undefined,
        [FilterSolicitationSearchFields.SolicitationChannelCode]: Channels.Onboarding,
        [FilterSolicitationSearchFields.SolicitationStateClassificationListCode]: undefined,
        [FilterSolicitationSearchFields.SolicitationTypeCode]: undefined
    }
    
    useEffect(() => {
        const filter: FilterSolicitationSearch = {
            ...defaultFilter,
            [FilterSolicitationSearchFields.ClientId]: clientId,
        }
        if (clientId) {
            HttpSolicitation.getSolicitations(filter).then((r) => {
                setSolicitations(r[EntityListWithPaginationFields.List])
            })
        }
    }, [clientId])
    
    return (
        <Grid item xs={12}>
            <Card>
                <CardHeader title={'Últimas solicitudes'} />
                <Divider sx={{width: '100%'}}/>
                <CardContent sx={{paddingTop: 0}}>
                    <Grid container sx={{width: '100% !important'}}>
                        {
                            solicitations ? 
                                solicitations.length !== 0 ?
                                    <Grid item xs={12}>
                                        <Table>
                                            <TableHead> 
                                                <TableRow>
                                                    <TableCell>Solicitud</TableCell>
                                                    <TableCell>Documentación</TableCell>
                                                    <TableCell>Tareas</TableCell>
                                                    <TableCell>Estado</TableCell>
                                                    <TableCell>Enviada el</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {solicitations.slice(0, 4).map((solic, index) => <SolicitationTableRow sol={solic} key={index}/>)}
                                            </TableBody>
                                        </Table>
                                    </Grid>
                                    :
                                    <Grid item xs={12} mt={4}><Alert severity={'info'}>Aún no se encontraron solicitudes para esta empresa</Alert></Grid>
                                :
                                Array.from({length: 5}).map((d, k) => <Grid item xs={12} key={k}><Skeleton height={60}/></Grid>)
                        }
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    )
}


export default HomeSolicitationsSummary